import App from './App.svelte';
import { mount } from 'svelte';
import './global.css';

// if ('serviceWorker' in navigator) {
//   window.addEventListener('load', () => {
//     navigator.serviceWorker
//       .register('/sw.js')
//       //     .then(reg => console.log('service worker registered', reg))
//       //     .catch(err => console.log('service worker not registered', err));
//   });
// }

const app = mount(App, { target: document.body });

export default app;
